import { DecoratorNode } from 'lexical'

export class BaseFormNode extends DecoratorNode {
  constructor(props, key) {
    super(key)
    this.__props = props || {}
  }

  setValue(value) {
    const writable = this.getWritable()
    writable.__props = { ...writable.__props, value }
  }

  onChange(editor, value) {
    editor.update(() => {
      this.setValue(value)
    })
  }
}
